import { useContext } from "react";
import { ActionType } from "./action.type.enum";
import { ModuleCode } from "./module.code.enum";
import { ConfigurationContext } from "components/provider/OrginazationContext";



export const useCheckHasPermission = (
  module_code: ModuleCode,
  actionType: ActionType
) => {
  const { permission } = useContext(ConfigurationContext);

  const modulePermission = permission?.find(
    (item: any) => item.module_code === module_code
  );

  return modulePermission ? modulePermission[actionType] : false;
};